import { render, staticRenderFns } from "./FolderEditForm.vue?vue&type=template&id=392ffab6"
import script from "./FolderEditForm.vue?vue&type=script&lang=js"
export * from "./FolderEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports